import React, { useState } from "react";
import {
  Slider,
  Switch,
  ToggleInput,
  ToggleLabel,
} from "./SwitchToggle.styles";

const SwitchToggle = ({checked, onChange}) => {
  return (
    <Switch>
      <ToggleLabel>
        <ToggleInput type="checkbox" checked={checked} onChange={onChange} />
        <Slider />
      </ToggleLabel>
    </Switch>
  );
};

export default SwitchToggle;
